import * as React from "react";
import classnames from "classnames";
import { Util, Link } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
import { getConcatClickTrackingAttributes } from "@grandvisionhq/svc-tealium/utils";
import { SubMenu } from "../../../../SubMenu/SubMenu/SubMenu.js";
/* empty css                 */
const SiteNavItem = ({
  label,
  link,
  childMenuItems = [],
  parameters,
  focusCallback,
  activeSubMenu,
  setActiveSubMenu
}) => {
  const hasSubmenu = childMenuItems?.length > 0;
  const shouldHandleSubmenu = !Util.isTouchDevice() && hasSubmenu;
  const linkRef = React.useRef();
  const isActive = React.useMemo(() => activeSubMenu === label, [activeSubMenu, label]);
  const [mouseOver, setMouseOver] = React.useState(false);
  React.useEffect(() => {
    if (isActive === mouseOver) {
      return;
    }
    const ms = mouseOver ? 400 : 200;
    const timeout = setTimeout(() => setActiveSubMenu(mouseOver ? label : ""), ms);
    return () => clearTimeout(timeout);
  }, [mouseOver]);
  const closeSubMenu = React.useMemo(
    () => () => {
      setActiveSubMenu("");
      linkRef.current?.focus();
    },
    [setActiveSubMenu, linkRef]
  );
  const handleMouseOver = () => setMouseOver(true);
  const handleMouseLeave = () => setMouseOver(false);
  const handleKeyDown = React.useCallback(
    (event) => {
      if (event.key === "Escape") {
        closeSubMenu();
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        setActiveSubMenu(activeSubMenu === label ? "" : label);
      }
    },
    [closeSubMenu, setActiveSubMenu, label]
  );
  const tealiumAttributes = getConcatClickTrackingAttributes(label, {
    "data-element-id": "MainNav"
  });
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      className: classnames("site-nav-item", {
        [`site-nav-item--${parameters?.menuKey}`]: !!parameters?.menuKey,
        _is_active: link?.active
      }),
      "data-t": "site-nav-item",
      onMouseOver: shouldHandleSubmenu ? handleMouseOver : void 0,
      onMouseLeave: shouldHandleSubmenu ? handleMouseLeave : void 0
    },
    /* @__PURE__ */ React.createElement(
      Link,
      {
        className: "site-nav-item__link",
        "data-t": "site-nav-item-link",
        url: link?.href,
        openInNewWindow: link?.openInNewWindow,
        onKeyDown: shouldHandleSubmenu ? handleKeyDown : void 0,
        onFocus: focusCallback,
        ref: linkRef,
        ariaHasPopup: hasSubmenu,
        ariaIsExpanded: isActive,
        tealiumAttributes
      },
      label,
      hasSubmenu && /* @__PURE__ */ React.createElement(Icon, { name: "chevron-down", height: 18, width: 18 })
    ),
    hasSubmenu && /* @__PURE__ */ React.createElement(
      SubMenu,
      {
        menuItems: childMenuItems,
        isActive,
        closeSubMenu,
        parentTealiumAttributes: tealiumAttributes
      }
    )
  );
};
export {
  SiteNavItem as default
};
//# sourceMappingURL=SiteNavItem.js.map
